import htmlEntities from '../scripts/html-entities';
import scrollToElement from 'scroll-to-element';
import DOMPurify from 'dompurify';
import merge from 'lodash.merge';

class SiteMessages {

  constructor () {

    this._messages = this.loadMessages();
    this.container = document.querySelector('.site-messages-container');

    this.loadMessages();

  }

  defaultStaticOptions() {
    return {
      id: false,
    }
  }

  defaultOptions() {
    return {
      id: false,
      save: 1,
      autoClose: 1,
      closeButton: true,
    }
  }

  scrollToMessages() {
    scrollToElement(this.container, {
      offset: -50,
    });
  }

  displayMessages(clearMessages = true) {

    this.container = document.querySelector('.site-messages-container');
    if(!this.container) {
      console.error("No site messages container");
      return;
    }

    console.log("messages", this._messages);

    let html = '';

    if(this._messages.length > 0) {
      html = `
      <div class="site-messages">
        ${this._messages.map(message => {
          return `
          <div class="site-message site-message--${htmlEntities(message.type)}" 
            data-autoclose="${message.options.autoClose}"
            ${message.options.id ? `data-id="${htmlEntities(message.options.id)}"` : ''}
          >
            <div class="site-message__content">
              ${DOMPurify.sanitize(message.message)}
            </div>
            ${message.options.closeButton ? `
            <div class="site-message__close">
              <button class="site-message__close__button">
                <i class="fas fa-times"></i>
              </button>
            </div>
            ` : ''}
            
          </div>
          `
        }).join('')}
      </div>
      `
    }

    this.container.innerHTML = html;

    console.log(this.container, html);

    let messages = this.container.querySelectorAll('.site-message');

    if(messages) {

      messages = Array.from(messages);

      messages.forEach((message, i) => {

        $(message).css('height', `${$(message).height()}`);
        let autoCloseTimeout = null;

        if($(message).data('autoclose') == 1) {

          autoCloseTimeout = setTimeout(() => {

            this.closeMessage(message);

          }, 10000 * (i + 1));

        }

        const closeBtn = message.querySelector('.site-message__close__button');

        if(closeBtn) {
          closeBtn.addEventListener('click', () => {
            clearTimeout(autoCloseTimeout);
            this.closeMessage(message);
          });
        }

      });

    }

    if(clearMessages) {
      this.clearMessages();
    }

  }

  closeMessage(message) {

    $(message).css('height', '0px');
    message.classList.add('animate-close');

    setTimeout(() => {
      message.parentNode.removeChild(message);
    }, 500);

  }

  clearMessages() {
    this._messages = [];
    this.saveMessages();
  }

  getMessages() {
    return this._messages;
  }

  removeMessageById(messageId) {

    if(this.container) {
      let messages = this.container.querySelectorAll('.site-message');

      if (messages) {

        messages = Array.from(messages);

        messages.forEach((message, i) => {
          if ($(message).data('id') == messageId) {
            $(message).remove();
          }
        });

      }
    }

  }

  addMessage(type, message, options = {}) {

    options = merge(this.defaultOptions(), options);

    // message id is unique, only add once
    if(options.id) {
      if(this._messages.length > 0) {
        for(let i = 0; i < this._messages.length; i++) {
          if(this._messages[i].options.id === options.id) {
            return;
          }
        }
      }
    }

    this._messages.push({
      message,
      type,
      options,
    });

    if(options.save) {
      this.saveMessages();
    }

  }

  saveMessages() {
    localStorage.setItem('siteMessages', JSON.stringify(this._messages));
  }

  loadMessages() {

    const messages = localStorage.getItem('siteMessages');

    if(messages) {
      return JSON.parse(messages);
    } else {
      return [];
    }

  }

}

const SiteMessagesInstance = new SiteMessages();

export default SiteMessagesInstance;
